module.exports = __webpack_public_path__ + "img/COCHABAMBA.4d0596de.png";